import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import "./index.css";

const Side = () => {
  const [animation, setAnimation] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimation(true);
    }, 1000);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className={`sidebar-view ${animation ? "active" : ""}`}>
      <Sidebar />
    </div>
  );
};

export default Side;
